export var TicketActionInputType;
(function (TicketActionInputType) {
    TicketActionInputType["UNKNOWN"] = "unknown";
    TicketActionInputType["CTA"] = "cta";
    TicketActionInputType["TEXT"] = "text";
})(TicketActionInputType || (TicketActionInputType = {}));
export const isTicketActionCtaInput = (input) => input.type === TicketActionInputType.CTA;
export const isTicketActionTextInput = (input) => input.type === TicketActionInputType.TEXT;
